module.exports = __webpack_public_path__ + "static/media/twoPeople.0b7e354d.png";